import { NgService } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IRootScope } from "@models";
import { Utils } from "@tools";

@NgService({
    token: Token.StorageService,
    dependencies: [
        Token.$RootScope
    ]
})
export class StorageService {
    constructor(
        private $rootScope: IRootScope
    ) {

    }

    public getFallbackImage() {
        return `${this.$rootScope.context.publicStorageUrl}/assets/images/cube.png`;
    }

    public getAssetUrl(relativePath: string) {
        return `${this.$rootScope.context.publicStorageUrl}/assets/${relativePath}`;
    }

    public getMediaUrl(relativePath: string) {
        if (Utils.isAbsoluteUrl(relativePath)) {
            return relativePath;
        } else {
            return `${this.$rootScope.context.publicStorageUrl}/media/${relativePath}`;
        }
    }

    public getProfileImageUrl(relativePath: string) {
        if (Utils.isAbsoluteUrl(relativePath)) {
            return relativePath;
        } else {
            // Adding a parameter to force the model to change (otherwise the image will not auto-load)
            // The parameter is unused and only serves to bust the cache
            return `${this.$rootScope.context.publicStorageUrl}/profileimages/${relativePath}?v=${(new Date()).getTime().toString()}`;
        }
    }

    /**
     * Gets the absolute url of a generic public blob file.  The relativePath given must include the container in this call (like media, mesh, etc)
     * @param relativePath 
     */
    public getFileUrl(relativePath: string) {
        return `${this.$rootScope.context.publicStorageUrl}/${relativePath}`;
    }
}
